import { render } from "./About.vue?vue&type=template&id=008487fa"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Gelo\\Desktop\\Firebase Project\\eporrtfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__